import {BroadcastService as BizkeytechBroadcastService} from "../../../@bizkeytech";


// --------------------------------------------------------

export interface AuthenticationMiddlewareBroadcastListener {
    (arg: AuthenticationMiddlewareBroadcastArg): void;
}

export interface AuthenticationMiddlewareBroadcastArg {
    type: 'login-successful',
    payload?: any,
}

// --------------------------------------------------------

export interface SearchBarSearchedBroadcastListener {
    (arg: SearchBarSearchedBroadcastArg): void;
}

export interface SearchBarSearchedBroadcastArg {
    type: 'searched',
    payload?: string,
}


// --------------------------------------------------------

export interface CurrentEmployeeProfileUpdatedBroadcastListener {
    (arg: CurrentEmployeeProfileUpdatedBroadcastArg): void;
}

export interface CurrentEmployeeProfileUpdatedBroadcastArg {
    type: 'firstName' | 'lastName',
    payload?: string,
}


/**@inheritdoc*/
class BroadcastService extends BizkeytechBroadcastService {

    /**
     * The names of the channels that are used in the application.
     */
    public static readonly channelNames = {
        ...super.channelNames,
        authenticationMiddleware: 'authentication-middleware',
        searchBarSearched: 'search-bar-searched',
        currentEmployeeProfileUpdated: 'current-employee-profile-updated',
    }
}

export * from 'broadcast-channel';
export type {BroadcastServiceAddEventListenerResult} from '../../../@bizkeytech';
export default BroadcastService;

